import React from 'react';
import styles from './FormFieldGroup.less';

export function FormFieldGroup({ requiredFieldMessage, children }) {
  return (
    <div className={styles.container}>
      <div className={styles.required}>
        <span className={styles.asterisk}>*</span> {requiredFieldMessage}
      </div>
      {children}
    </div>
  );
}
